import session from '@/api/session';


const initialState = {
    settings: {}
};

const getters = {
    getSettings: state => state.settings
};

const actions = {
    fetchSettings({ commit }) {
        const url = "adminsettings";

        session.get(url, {}).then((response) => {
            let tmp = Object.assign(
                {},
                ...response.data.results.map((x) => ({ [x.name]: x.value }))
            );

            commit("setSettings", tmp);
        });
    }
};

const mutations = {
    setSettings(state, payload) {
        state.settings = payload;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};
